import { DEGREE_TYPES, PROGRAM_DROPDOWN } from "../../ProgramMenu/form-constants";

export { formatDate, generateUniqueId } from "@/utils/leadHelpers";

const SELECT_DEGREE = "Select Degree";
const SELECT_PROGRAM = "Select Program";
const SELECT_SLOT = "Select Slot";

const precedentSelectedPrograms = (associatedPrograms: Array<ProgramDetails>) =>
  associatedPrograms.map((selectedProgram) =>
    selectedProgram.attributes.BasicDetails?.Heading.toUpperCase()
  );

const getProgramId = ({
  isLandingPage,
  associatedPrograms,
  program,
  isProgramListPage = false,
}: {
  isLandingPage: boolean;
  associatedPrograms: Array<ProgramDetails>;
  program: String;
  isProgramListPage?: boolean;
}) =>
  isLandingPage || isProgramListPage
    ? associatedPrograms.find(
        (selectedProgram) =>
          selectedProgram.attributes.BasicDetails?.Heading.toUpperCase() ==
          String(program).toUpperCase()
      )?.attributes.BasicDetails?.PROGRAM_ID || ''
    : PROGRAM_DROPDOWN.find((e) => String(e.title).toLowerCase() == String(program).toLowerCase())
        ?.id || "";

      

const filterSelectedPrograms = ({
  associatedPrograms,
  degree = SELECT_DEGREE,
}: {
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
}) => {
  return associatedPrograms.filter(
    (programOption) =>
      (programOption.attributes.BasicDetails?.ProgramType === DEGREE_TYPES[degree]?.id ||
        degree == SELECT_DEGREE) &&
      !!programOption.attributes.BasicDetails?.Heading
  );
};

/**
 * Pure Degree → Program options derivation (replaces useEffect + setProgramsList).
 * Landing: filter associatedPrograms. Otherwise: filter PROGRAM_DROPDOWN by degree,
 * falling back to programListFinal, then geo-exclude when country ≠ IN.
 */
const buildProgramsListForDegree = ({
  isLandingPage,
  associatedPrograms,
  degree,
  programListFinal,
  countryCode,
  excludeProgramsOutsideIndia = [],
}: {
  isLandingPage: boolean;
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
  programListFinal: string[];
  countryCode?: string | null;
  excludeProgramsOutsideIndia?: string[];
}): string[] => {
  if (isLandingPage) {
    return precedentSelectedPrograms(
      filterSelectedPrograms({ associatedPrograms, degree }),
    );
  }

  const list = PROGRAM_DROPDOWN.filter(
    (x: any) => x.programType == degree,
  ).map((x: any) => x.title);

  let finalProgramsList = list?.length ? list : programListFinal;

  if (countryCode && countryCode !== "IN") {
    finalProgramsList = finalProgramsList.filter(
      (x: any) => !excludeProgramsOutsideIndia.includes(x),
    );
  }

  return finalProgramsList;
};

export {
  precedentSelectedPrograms,
  getProgramId,
  SELECT_DEGREE,
  SELECT_SLOT,
  SELECT_PROGRAM,
  filterSelectedPrograms,
  buildProgramsListForDegree,
};
